import { useEffect } from 'react';

const BASE_TITLE = 'Value Flow Game';

export function useDocumentTitle(title?: string | null) {
  useEffect(() => {
    const previousTitle = document.title;

    if (title) {
      document.title = title;
    } else {
      document.title = BASE_TITLE;
    }

    // Cleanup: restore previous title when component unmounts
    return () => {
      document.title = previousTitle;
    };
  }, [title]);
}

export function useTeamDocumentTitle(teamName?: string | null) {
  useDocumentTitle(teamName);
}
